import React from "react";
import { UserCheck } from "lucide-react";
import { EXISTING_PATIENT_MSG } from "@/hooks/usePhoneCheck";

export default function ExistingPatientAlert({ patient, testId = "existing-patient-alert" }) {
  if (!patient) return null;
  return (
    <div data-testid={testId} className="flex gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
      <UserCheck className="mt-0.5 h-4 w-4 shrink-0" />
      <div>
        <div className="font-medium">{EXISTING_PATIENT_MSG}</div>
        <div className="mt-0.5 text-xs">
          {patient.name}{patient.medical_record_no ? ` • No RM ${patient.medical_record_no}` : ""} • {patient.phone}
        </div>
      </div>
    </div>
  );
}
